/* Keep the customer's full-text query intact. Split complete matches before paging. */
(() => {
  const fields=`pageInfo{hasNextPage hasPreviousPage startCursor endCursor} totalCount nodes{...on Product{
    id handle title productType tags availableForSale featuredImage{url(transform:{maxWidth:600})}
    priceRange{minVariantPrice{amount currencyCode} maxVariantPrice{amount currencyCode}}}}`;
  function filters(params){
    const result=[],price={};
    for(const key of new Set(params.keys())){
      if(!key.startsWith('filter.'))continue;
      const values=params.getAll(key).filter(v=>v!=='');if(!values.length)continue;
      if(key==='filter.v.availability'){if(values.length===1)result.push({available:values[0]==='1'});}
      else if(key==='filter.v.price.gte'||key==='filter.v.price.lte'){
        const value=Number(values[0]);if(!Number.isFinite(value)||value<0)throw Error('Native filter');price[key.endsWith('gte')?'min':'max']=value;
      }else throw Error('Native filter'); // Unconfigured Storefront facets can silently be ignored.
    }
    if(Object.keys(price).length)result.push({price});return result;
  }
  function init(root){
    if(root.dataset.initialized||!root.querySelector('[data-search-enhanced]'))return;root.dataset.initialized='true';
    const ui=window.KillinSearchResults,params=new URL(location.href).searchParams,q=params.get('q')||'';
    if(!q.trim()||(params.get('type')&&!params.get('type').split(',').includes('product')))return;
    const sort=params.get('sort_by')||'relevance';if(!['relevance','price-ascending','price-descending'].includes(sort))return;
    let productFilters;try{productFilters=filters(params);}catch{return;}
    const enhanced=root.querySelector('[data-search-enhanced]'),fallback=root.querySelector('[data-search-fallback]');
    const grid=root.querySelector('[data-search-singles]'),status=root.querySelector('[data-search-status]');
    const panel=ui.panel(root),more=panel.aside.querySelector('[data-bundle-more]'),bundleStatus=panel.aside.querySelector('[data-bundle-status]');
    let bundleItems=[],bundleLimit=50;
    const requests=new Set();window.addEventListener('pagehide',()=>requests.forEach(c=>c.abort()),{once:true});
    async function request(query,variables){
      const controller=new AbortController();requests.add(controller);const timer=setTimeout(()=>controller.abort(),20000);
      try{
        const response=await fetch('/api/2026-07/graphql.json',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({query,variables}),signal:controller.signal});
        if(!response.ok)throw Error('Search unavailable');const body=await response.json();if(body.errors||!body.data)throw Error('Search unavailable');return body.data;
      }finally{clearTimeout(timer);requests.delete(controller);}
    }
    const country=/^[A-Z]{2}$/.test(root.dataset.country)?root.dataset.country:'CA';
    const variables={q,filters:productFilters,country,sort:sort.startsWith('price-')?'PRICE':'RELEVANCE',reverse:sort==='price-descending'};
    const query=`query($q:String!,$filters:[ProductFilter!],$country:CountryCode!,$sort:SearchSortKeys!,$reverse:Boolean!,$after:String) @inContext(country:$country){
      matches:search(first:100,after:$after,types:[PRODUCT],query:$q,productFilters:$filters,sortKey:$sort,reverse:$reverse){${fields}}}`;
    async function matchingProducts(){
      const products=new Map(),cursors=new Set();let after=null,total=null;
      for(let page=0;page<10;page++){
        const {matches}=await request(query,{...variables,after});
        // Search caps its result count at 1000. Keep native paging for broad
        // searches rather than present a partial catalogue as complete.
        if(!matches||!Number.isInteger(matches.totalCount)||matches.totalCount>=1000||
          (total!==null&&total!==matches.totalCount))throw Error('Use native search');
        total=matches.totalCount;
        for(const p of matches.nodes){if(!p.id||!p.handle)throw Error('Incomplete search result');products.set(p.id,p);}
        if(!matches.pageInfo.hasNextPage){
          if(products.size!==total)throw Error('Incomplete search results');
          return [...products.values()];
        }
        after=matches.pageInfo.endCursor;
        if(!after||cursors.has(after))throw Error('Search pagination unavailable');cursors.add(after);
      }
      throw Error('Use native search');
    }
    function showBundles(){
      const visible=bundleItems.slice(0,bundleLimit);panel.update(visible,bundleItems.length);more.hidden=bundleLimit>=bundleItems.length;
      bundleStatus.textContent=more.hidden?'':visible.length+' of '+bundleItems.length+' bundles loaded';
    }
    more.addEventListener('click',()=>{bundleLimit+=50;showBundles();});
    // Native results stay visible while loading and on any API/parser failure.
    matchingProducts().then(products=>{
      const singles=products.filter(p=>!ui.isBundle(p));bundleItems=products.filter(ui.isBundle);
      const count=singles.length,pages=Math.max(1,Math.ceil(count/24));
      const page=Math.min(pages,Math.max(1,Math.floor(Number(params.get('page'))||1)));
      grid.replaceChildren(...singles.slice((page-1)*24,page*24).map(p=>ui.card(p,root)));
      status.textContent=count+' singles'+(count?' · '+(sort==='price-descending'?'Price, high to low':sort==='price-ascending'?'Price, low to high':'Best match')+' · Page '+page+' of '+pages:'');
      if(!count){grid.append(ui.el('p',bundleItems.length?'No matching singles right now. Explore the related bundles or save this search.':'No matching singles. Try another name, artist or set.','empty-state'));
        if(window.KillinWishlist)grid.append(window.KillinWishlist.button({type:'search',query:q,title:q}));}
      showBundles();
      for(const [name,has,target] of [['prev',page>1,page-1],['next',page<pages,page+1]]){
        const link=root.querySelector('[data-search-'+name+']');link.hidden=!has;
        if(has){const url=new URL(location.href);for(const remove of ['search_after','search_before','page'])url.searchParams.delete(remove);url.searchParams.set('page',target);link.href=url.pathname+url.search;}
      }
      enhanced.hidden=false;fallback.hidden=true;
      if(window.KillinWishlist)window.KillinWishlist.refresh();
    }).catch(()=>{enhanced.hidden=true;fallback.hidden=false;}).finally(()=>grid.setAttribute('aria-busy','false'));
  }
  const boot=()=>document.querySelectorAll('[data-card-search]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();
